import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function DoubleCheckCircle(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 19.36 15">
      <path d="M11.41,12.05c-1.08.93-2.47,1.45-3.91,1.45-3.31,0-6-2.69-6-6S4.19,1.5,7.5,1.5c.97,0,1.89.22,2.75.66.37.19.82.04,1.01-.32.19-.37.05-.82-.32-1.01-1.05-.54-2.24-.83-3.43-.83C3.36,0,0,3.36,0,7.5s3.36,7.5,7.5,7.5c1.79,0,3.53-.64,4.88-1.81.31-.27.35-.74.08-1.06-.27-.31-.74-.35-1.06-.08ZM10.67,6.71l4.23-4.24c.29-.29.29-.77,0-1.05s-.77-.29-1.06,0l-4.23,4.23,1.06,1.06ZM19.14,1.42h0c-.28-.3-.76-.3-1.05,0l-7.41,7.41-2.61-2.6c-.29-.29-.77-.29-1.06,0-.29.29-.29.76,0,1.06l3.14,3.13c.29.29.77.29,1.06,0l7.94-7.93c.29-.29.29-.76,0-1.06ZM2.77,7.29l3.14,3.14c.29.29.77.29,1.06,0l.52-.52-3.66-3.67c-.29-.29-.77-.29-1.06,0-.29.29-.29.77,0,1.06Z" />
    </SvgIcon>
  );
}
